package fr.labodoc.healthProfessional.api.payloads.requests

import fr.labodoc.domain.labodoc.common.NotificationFrequency
import kotlinx.serialization.Serializable

@Serializable
sealed class FreestandingApplicationRequest {
  @Serializable
  data class HealthProfessional(
    val rppsNumber: String?,
    val firstName: String,
    val lastName: String,
    val phoneNumber: String,
    val medicalSpeciality: String,
    val medicalInterests: List<String>,
    val facilityName: String,
    val facilityUnit: String,
    val facilityCity: String,
    val facilityDepartmentCode: String,
    val notificationFrequency: NotificationFrequency?,
    val emailAddress: String,
    val password: String,
    val comment: String?,
    val partnerCode: String?
  ) : FreestandingApplicationRequest()

  @Serializable
  data class Extern(
    val firstName: String,
    val lastName: String,
    val universityHospitalId: String,
    val notificationFrequency: NotificationFrequency?,
    val emailAddress: String,
    val password: String,
    val comment: String?,
    val partnerCode: String?
  ) : FreestandingApplicationRequest()
}
